// Zentrale Firmen-/Datenschutz-Angaben für Einwilligungstexte in den Lead-Formularen.
// Richtet sich nach dem eingeloggten Ersteller-User: zuerst Agentur, dann Organisation.
// Muss inhaltlich zur Backend-Config passen (api/mail_config.php -> getBrandingConfig).
export function getConsentBranding(user) {
  const agenturId = Number(user?.agentur_id);
  const orgId = Number(user?.organization_id);

  // Agentur-spezifisch (hardcoded)
  if (agenturId === 64) {
    return {
      // Rechtlicher Firmenname bleibt "Energie Sorglos GmbH"; Zusatz ist Branding
      companyName: 'Energie Sorglos GmbH (powered by Vattenfall)',
      datenschutzUrl: 'https://www.energiesorglos.de/datenschutzerklarung/'
    };
  }

  // Organisation
  if (orgId === 6) {
    return {
      companyName: 'Energie Plus GmbH',
      datenschutzUrl: 'https://www.energie-plus.de/datenschutz/'
    };
  }

  // Default: Bundesenergie Nord
  return {
    companyName: 'Bundesenergie Nord BEN GmbH',
    datenschutzUrl: 'https://www.bundesenergie-nord.de/datenschutz/'
  };
}
